import React from 'react'
import styled from '@emotion/styled'

interface DivStyledProps {
  row?: boolean
  bottomPadding?: boolean
  mobileRow?: boolean
}

interface SectionRowProps
  extends React.HTMLAttributes<HTMLDivElement>, DivStyledProps {}

const Div = styled.div<DivStyledProps>`
  max-width: 750px;
  padding-bottom: ${({ bottomPadding }) => (bottomPadding ? '20px' : '0px')};
  display: ${({ row }) => (row === true ? 'grid' : 'block')};
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;

  @media screen and (max-width: 600px) {
    grid-template-columns: ${({ mobileRow }) =>
      mobileRow ? '1fr 1fr' : '1fr'};
    display: ${({ mobileRow }) => (mobileRow ? 'grid' : 'block')};
  }
`

const SectionRow: React.FC<SectionRowProps> = ({
  children,
  bottomPadding = true,
  mobileRow = false,
  ...props
}) => {
  return (
    <Div {...props} bottomPadding={bottomPadding} mobileRow={mobileRow}>
      {children}
    </Div>
  )
}

export default SectionRow
